import { Dispatch, useCallback } from "react";
import { CompraActions, CompraActionUnion } from "./Compra.Actions";
import CompraService from "../../Data/Services/CompraService";
import { ICompraEffects } from "./Interfaces/ICompraEffects";
import { ISaveCompra } from "../../Data/Interfaces/Request/Compra/ISaveCompra";
import { FormikHelpers, FormikValues } from "formik";
import { IResponse } from "../../Data/Interfaces/Base/IResponse";
import { IViaCepResponse } from "../../Data/Interfaces/Responses/ViaCep/IViaCepResponse";
import ViaCepService from "../../Data/Services/ViaCepService";
import { IResponseCompra } from "../../Data/Interfaces/Responses/Compra/IResponseCompra";

export type CompraEffectsType = (
  dispatch: Dispatch<CompraActionUnion>
) => ICompraEffects;

export const CompraEffects: CompraEffectsType = (
  dispatch: Dispatch<CompraActionUnion>
) => ({
  saveCompra: useCallback(
    async (
      compra: ISaveCompra,
      hasLogin: boolean,
      helpers: FormikHelpers<FormikValues>
    ) => {
      try {
        dispatch(CompraActions.setLoading(true));
        const { data } = await CompraService.fetchCompra(
          {
            ...compra,
            endereco: compra.endereco
              ? {
                  ...compra.endereco,
                  nome: "Plano Saude",
                  principal: true,
                }
              : undefined,
          },
          hasLogin
        );
        const result = data as IResponse<IResponseCompra>;

        const hasFatura =
          (result.data.recent_invoices &&
            result.data.recent_invoices[0] &&
            compra.payable_with !== "credit_card") ||
          false;

        if (
          hasFatura &&
          result.data.recent_invoices &&
          result.data.recent_invoices[0]
        ) {
          window.open(`${result.data.recent_invoices[0].secure_url}`, "_BLANK");
        }
        dispatch(
          CompraActions.saveComprasSuccess({
            ...result,
            data: {
              ...result.data,
              hasFatura: hasFatura,
              paiedWithCreditCard: compra.payable_with === "credit_card",
            },
          })
        );
        helpers.setSubmitting(false);
        compra.onSuccess(hasFatura);
      } catch (err: any) {
        dispatch(CompraActions.saveComprasFailed(err));
        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.error &&
          err.response.data.error.email
        ) {
          helpers.setFieldError(
            "email",
            (err.response.data.error.email &&
              err.response.data.error.email.msg) ||
              ""
          );
        } else {
          helpers.setFieldError(
            "email",
            (err && err.error && err.error.detail) ||
              (err && err.error && err.error.errorMessage) ||
              (err && err.error && err.error.err) ||
              (err && err.error && err.error) ||
              (err &&
                err.response &&
                err.response.data &&
                JSON.stringify(err.response.data))
          );
        }

        window.scrollTo({
          top: 40,
          behavior: "smooth",
        });

        helpers.setSubmitting(false);
      } finally {
        dispatch(CompraActions.setLoading(false));
      }
    },
    [dispatch]
  ),
  loadCep: useCallback(
    async (
      cep: string,
      { setFieldError, setFieldValue }: FormikHelpers<FormikValues>
    ) => {
      const updateAdressValues = async ({
        cep,
        bairro,
        localidade,
        logradouro,
        complemento,
        uf,
        ...value
      }: IViaCepResponse): Promise<void> => {
        setFieldValue("endereco.bairro", bairro);
        setFieldValue("endereco.logradouro", logradouro);
        setFieldValue("endereco.complemento", complemento);
        setFieldValue("endereco.cidade", localidade);
        setFieldValue("endereco.estado", uf);

        try {
          const { data } = await ViaCepService.getLatLng(cep);
          const { location } = data.results[0].geometry;
          setFieldValue("endereco.latitude", location.lat);
          setFieldValue("endereco.longitude", location.lng);
        } catch {}
      };
      try {
        dispatch(CompraActions.setLoading(true));
        const { data } = await ViaCepService.getAdress(cep);
        await updateAdressValues(data);
      } catch (err: any) {
        await updateAdressValues({} as IViaCepResponse);
        setFieldError("endereco.cep", "Este CEP é invalido");
      } finally {
        dispatch(CompraActions.setLoading(false));
      }
    },
    [dispatch]
  ),
});
